/*!
 * UTM attribution tracker — 订单归因数据源（店铺专属看板 App 的地基）
 * 职责：
 *   1. 落地页抓取 URL 上的 utm_* 参数（及 referrer/落地页），本地留存 30 天；
 *      first-touch 首次进站渠道恒定不变，last-touch 每次带新参数进站时更新。
 *   2. 将归因字段写入 Shopify 购物车属性（/cart/update.js）→ 结账自动携带 →
 *      订单后台「其他详细信息」直接可见，Admin API noteAttributes 可读。
 *   3. 会话内去重：同会话参数未变化不重复请求；UTM 变化（新渠道进来）立即刷新。
 * 无依赖、无 Cookie（localStorage）、对 SEO/性能零影响（sendBeacon 异步）。
 */
(function () {
  'use strict';
  var KEY = 'pd_utm_v1', TTL = 30 * 24 * 3600 * 1000;
  var FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save(o) {
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }

  var q = {};
  location.search.replace(/[?&]([a-z_]+)=([^&#]+)/gi, function (_, k, v) {
    q[k.toLowerCase()] = decodeURIComponent(v);
    return _;
  });
  var hasUtm = FIELDS.some(function (f) { return q[f]; });

  var now = Date.now();
  var store = read() || { first: {}, last: {} };
  if (store.ts && now - store.ts > TTL) store = { first: {}, last: {} };  // 过期重置归因窗口

  if (hasUtm) {
    var touch = { source: q.utm_source || '', medium: q.utm_medium || '', campaign: q.utm_campaign || '', content: q.utm_content || '', term: q.utm_term || '' };
    if (!store.first || !store.first.ts) store.first = Object.assign({ ts: now }, touch);
    store.last = Object.assign({ ts: now }, touch);
  }
  if (!store.first || !store.first.ts) {
    /* 无 UTM 的首访也记渠道线索：referrer 域名（供看板把"直接访问"细分出社媒域） */
    var ref = document.referrer || '';
    if (ref && ref.indexOf(location.hostname) < 0) {
      var m = ref.match(/^https?:\/\/([^\/]+)/);
      if (!store.first || !store.first.ts) store.first = { ts: now, source: (m ? m[1] : 'referrer'), medium: 'referral' };
      if (!store.last || !store.last.ts) store.last = { ts: now, source: (m ? m[1] : 'referrer'), medium: 'referral' };
    }
  }
  store.landing = store.landing || location.pathname;
  store.ts = now;
  save(store);

  /* —— 写入购物车属性（结账/订单自动携带）—— */
  var attrs = {
    'utm source': store.last.source || '',
    'utm medium': store.last.medium || '',
    'utm campaign': store.last.campaign || '',
    'utm content': store.last.content || '',
    'utm first touch': store.first.ts ? new Date(store.first.ts).toISOString().slice(0, 10) + ' · ' + (store.first.source || '') + '/' + (store.first.medium || '') + '/' + (store.first.campaign || '') : '',
    'utm last touch': store.last.ts ? new Date(store.last.ts).toISOString().slice(0, 10) + ' · ' + (store.last.source || '') + '/' + (store.last.medium || '') + '/' + (store.last.campaign || '') : '',
    'landing page': store.landing || ''
  };
  var fingerprint = JSON.stringify(attrs);
  var SENT = 'pd_utm_sent';
  try {
    if (sessionStorage.getItem(SENT) === fingerprint) return;   // 本会话已同步且无变化
    sessionStorage.setItem(SENT, fingerprint);
  } catch (e) {}
  var body = JSON.stringify({ attributes: attrs });
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/json' }));
  } else {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
  }
})();
